import PropTypes from 'prop-types';
import React from 'react';
import { Table } from 'react-bootstrap';
import { isArray } from 'lodash';
import { getOrgTermsContent } from '../../content/utils.js';
import styles from './CategoriesTable.module.css';

const CategoriesTableRow = (category, onShowModal, initiativeType) => (
  <React.Fragment>
    <tr key={`${category.initiativeType}${category.id}`}>
      <td style={{ paddingLeft: '102px', width: '50%' }}>
        <h3>{category.name}</h3>
      </td>
      <td style={{ width: '25%' }}>
        <strong>{category.projectsCount}</strong>
      </td>
      <td style={{ width: '25%' }}>
        <strong>{category.initiativesCount}</strong>
      </td>
    </tr>
  </React.Fragment>
);

const CategoriesTable = ({
  initiativeCategories,
  onShowModal,
  initiativeType,
}) => (
  <Table hover className={styles.categoriesTable}>
    <thead>
      <tr>
        <th style={{ paddingLeft: '102px' }}>Title</th>
        <th>{getOrgTermsContent('projects')}</th>
        <th>{getOrgTermsContent('initiatives')}</th>
      </tr>
    </thead>
    <tbody>
      {isArray(initiativeCategories)
        ? initiativeCategories.map((category) =>
            CategoriesTableRow(category, onShowModal, initiativeType)
          )
        : null}
    </tbody>
  </Table>
);

CategoriesTable.propTypes = {
  initiativeCategories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      initiativeType: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default CategoriesTable;
